import * as React from 'react';
import * as numeral from 'numeral';
import { renderEmpty } from '../../common/Render';
import translate from '../../../../locale/translate';

import { IReportSettings } from '../../../../interfaces';

import ISettings from './ISettings';
import { IWidgetProps } from '../../StateWidgetContainer';

import { calcStats, calcChildErrors, IStateStats } from '../../util/StateUtil';

interface IProps extends IWidgetProps {
    settings: ISettings;
}

export default class Widget extends React.Component<IProps, void> {
    static propTypes = {
        nodes: React.PropTypes.array.isRequired,
        states: React.PropTypes.object.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    getStats(nodes, states, settings: ISettings, reportSettings: IReportSettings) {
        const startDate = new Date(reportSettings.startMs);
        const endDate = new Date(reportSettings.endMs);

        const nodeStats = nodes.reduce((map, node) => {
            map[node.id] = calcStats(states[node.id], startDate, endDate, settings.shortMinutes, settings.longMinutes);
            return map;
        }, {});

        const servers = nodes.filter((node) => {
            return node.subtype === 2 && node._searchIdx.tagIds.indexOf('server') >= 0;
        });

        const workstations = nodes.filter((node) => {
            return node.subtype === 2 && node._searchIdx.tagIds.indexOf('workstation') >= 0;
        });

        const serverInErrorSum = servers.reduce((total, server) => {
            const stats = nodeStats[server.id] as IStateStats;
            total.msInError += stats.msInError;
            total.msTotal += stats.msTotal;

            return total;
        }, { msInError: 0, msTotal: 0 });

        const avgServerAvailability = 1 - (serverInErrorSum.msInError / serverInErrorSum.msTotal);

        const errorStats = nodes.reduce(function (total, system) {
            const stats = nodeStats[system.id] as IStateStats;

            total.totalCount += stats.errorCount;
            total.shortErrorCount += stats.shortErrorCount;
            total.mediumErrorCount += stats.mediumErrorCount;
            total.errorDuration += stats.msInError;

            return total;
        }, {
                totalCount: 0,
                errorDuration: 0,
                shortErrorCount: 0,
                mediumErrorCount: 0
            });

        return {
            servers,
            workstations,
            avgServerAvailability,
            errorStats,
        };
    }

    renderData(nodes, states, settings: ISettings, reportSettings: IReportSettings) {
        const stats = this.getStats(nodes, states, settings, reportSettings);

        return (
            <table className="table">
                <tbody>
                    <tr>
                        <td>{translate.gettext("Monitored servers")}</td>
                        <td>{stats.servers.length}</td>
                    </tr>
                    <tr>
                        <td>{translate.gettext("Average availability of all monitored servers")}</td>
                        <td>{numeral(stats.avgServerAvailability).format('0.00%')}</td>
                    </tr>
                    <tr>
                        <td>{translate.gettext("Monitored PCs")}</td>
                        <td>{stats.workstations.length}</td>
                    </tr>
                    <tr>
                        <td>{translate.gettext("Total alerts")}</td>
                        <td>{stats.errorStats.totalCount}</td>
                    </tr>
                    <tr>
                        <td>
                            {translate.format(translate.gettext("Alerts resolved within {minutes} minutes"), {
                                minutes: settings.shortMinutes
                            })}
                        </td>
                        <td>{numeral(stats.errorStats.shortErrorCount / stats.errorStats.totalCount).format('0.00%')}</td>
                    </tr>
                    <tr>
                        <td>
                            {translate.format(translate.gettext("Alerts resolved within {minutes} minutes"), {
                                minutes: settings.longMinutes
                            })}
                        </td>
                        <td>{numeral(stats.errorStats.mediumErrorCount / stats.errorStats.totalCount).format('0.00%')}</td>
                    </tr>
                </tbody>
            </table>
        );
    }

    render() {
        const { nodes, states, settings, reportSettings } = this.props;

        let renderedData;
        if (nodes && nodes.length) {
            renderedData = this.renderData(nodes, states, settings, reportSettings);
        } else {
            renderedData = renderEmpty();
        }

        return (
            <div>
                {renderedData}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/alerts/monitoringOverview/Widget.tsx